// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { LocationSelectionProps } from '@dip/helsecore/src/components/parts/LocationSelection/LocationSelection.d';

import React from 'react';
import { LocationSelection } from '@dip/helsecore/src/components/parts/LocationSelection/LocationSelection';

export default (props: Readonly<LocationSelectionProps>) => <LocationSelection {...props} />
